import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the element matching `location.hash` whenever the route or hash
// changes. This makes anchor links like `/#services` work after a route change
// (e.g. clicking a section link from /company-training).
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one tick so the new route's DOM has mounted.
      const id = hash.replace("#", "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };
      if (!tryScroll()) {
        // retry shortly in case the section isn't mounted yet
        const t = setTimeout(tryScroll, 120);
        return () => clearTimeout(t);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname, hash]);

  return null;
}
